import { memo, useEffect, useState } from 'react';

import { Select, Tooltip } from 'antd';

import { SEARCH_THRESHOLD, TABLE_SELECT_OUTPUT } from '../../constants/common';

function AppTableSelect({ col, disabled, mode, output, value = '', record, handleChange }) {
  const isMultipleMode = mode === 'multiple';
  const isValueOutput = output === TABLE_SELECT_OUTPUT.VALUE;

  const formattedValue = value && typeof value === 'object' && !Array.isArray(value) ? value.name : value;

  const defaultObj = col.editConfig.options?.find(
    option => option.value === formattedValue || option.label === formattedValue
  );

  const initialValue =
    isMultipleMode && Array.isArray(formattedValue)
      ? formattedValue
      : (defaultObj?.value ?? (typeof formattedValue === 'string' ? formattedValue : ''));

  const [selectedValue, setSelectedValue] = useState(initialValue);

  useEffect(() => {
    const newObj = col.editConfig.options?.find(
      option => option.value === formattedValue || option.label === formattedValue
    );

    const newVal =
      isMultipleMode && Array.isArray(formattedValue)
        ? formattedValue
        : (newObj?.value ?? (typeof formattedValue === 'string' ? formattedValue : ''));

    setSelectedValue(newVal);
  }, [value, col.editConfig.options]);

  const handleOnChange = (value, option) => {
    setSelectedValue(isValueOutput ? value : option);
    handleChange({ ...record, [col.dataIndex]: isValueOutput ? value : option });
  };

  return (
    <Select
      size="small"
      variant="borderless"
      disabled={disabled}
      mode={mode || undefined}
      options={col.editConfig.options}
      showSearch={col.editConfig.options?.length >= SEARCH_THRESHOLD}
      style={{ height: isMultipleMode ? 'auto' : '21px', width: '100%' }}
      value={selectedValue}
      onChange={handleOnChange}
      optionRender={option => (
        <Tooltip title={option.data.description ? option.data.description : ''} placement="top">
          {option.label}
        </Tooltip>
      )}
    />
  );
}

export default memo(AppTableSelect);
